<template>
  <ol class="breadcrumb">
    <li
      v-for="(item, index) in list"
      class="breadcrumb-item">
      <template v-if="showName(item)">
        <span
          v-if="isLast(index)"
          class="active">{{ showName(item) }}</span>
        <router-link
          v-else
          :to="{ name: item.name }">{{ showName(item) }}</router-link>
      </template>
    </li>
  </ol>
</template>

<script>
  export default {
    props: {
      separator: String
    },
    computed: {
      list () {
        return this.$route.matched
      }
    },
    methods: {
      isLast (index) {
        return index === this.list.length - 1
      },
      showName (item) {
        if (!item.name) {
          return false
        }

        if (item.meta && item.meta.label) {
          item = item.meta && item.meta.label
        }
        if (item.name) {
          item = item.name
        }
        return item
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?38d4a92a